import React, {useEffect} from "react";

function Logout() {
    useEffect(() => {
        document.title = "Geoticket - Logout";
    }, []);
    useEffect(() => {
        fetch(global.route.logout, {
            method: "post", credentials: 'include'
        })
            .then(response => {
                if (response.status === 200) {
                    window.location.href = "/";
                } else {
                    window.history.back();
                }
            });
    }, []);


    return (<div/>);
}

export default Logout;